<template>
  <div class="text-center">
    <h5 class="mt-2 black--text">
      <b>Ventana de Mantenimiento</b>
    </h5>

    <h6 v-if="userName" class="black--text">
      <b>¡Bienvenido (a) "{{ userName }}"!</b>
    </h6>

    <maintenance-logo no-link />

    <h5 class="mt-1 black--text">
      <b>¡ATENCIÓN!</b>
    </h5>

    <p class="mt-2 h6 black--text">
      Actualmente estamos trabajando para darte la mejor experiencia en IEL, por
      esta razón toda
      <b>{{ disabledModuleText }}</b> se encuentra inhabilitada.
      <br />Agradecemos mucho tu comprensión.
    </p>
  </div>
</template>

<script>
  import MaintenanceLogo from '../MaintenanceLogo.vue';

  export default {
    name: 'MaintenanceOptionModal',

    components: {
      MaintenanceLogo,
    },

    props: {
      userName: {
        type: String,
        default: '',
      },
      disabledModule: {
        type: String,
        required: true,
      },
      loading: Boolean,
    },

    computed: {
      disabledModuleText() {
        switch (this.disabledModule) {
          case 'billing':
            return 'facturación de pedidos';
          default:
            return '';
        }
      },
    },
  };
</script>
